import mapPricingResponse from '../Mappers/mapPricingResponse';
import { api } from './api';

export default async function fetchPricingData(country, accessToken) {
	const res = await api.get('/GetPricingFilteredByCountry', {
		params: {
			siteId: country.code,
			skuIsNotNull: 1,
			limit: 1500,
			offSet: 0,
		},
		headers: {
			Authorization: `Bearer ${accessToken}`,
			accept: '*/*',
		},
	});

	const data = mapPricingResponse(res, country.name);

	return data;
}
